module.exports = __webpack_public_path__ + "static/media/login-logo.e1a16dbc.svg";